import React from "react";
import { IInputProps, Input } from "./input";
import { HexColorPicker } from "react-colorful";
import { TetherTarget } from "../tether-target";
import { Popover } from "../popover/popover";
import classNames from "classnames";
import { Button } from "../button/button";
import _ from "lodash";
import { TextMaskInput } from "./text-mask-input";

interface IColorPickerProps extends IInputProps {

}

interface IColorPickerState {
  draftValue?: string
  isColorPickerOpen?: boolean
}

const HEX_RE = /[0-9a-fA-F]/
const HEX_COLOR_MASK = ['#', HEX_RE, HEX_RE, HEX_RE, HEX_RE, HEX_RE, HEX_RE]
const COLOR_RE = /#[0-9a-fA-F]{6}/
const DEFAULT_COLOR = '#ffffff'

export class ColorPicker extends React.Component<IColorPickerProps, IColorPickerState> {
  constructor(props) {
    super(props)

    this.state = {}
  }

  public render() {
    const { value } = this.props
    const { isColorPickerOpen } = this.state
    const safeValue = value || DEFAULT_COLOR

    return <>
      <div className='c-formGroup'>
        <div className='c-formGroup c-formGroup--isHorizontal'>
          <TextMaskInput {...this.props} onChange={this.handleChangeSafely} value={safeValue} mask={HEX_COLOR_MASK} />
          <div onClick={this.handleShowColorPicker} style={{
            height: '16px',
            width: '16px',
            backgroundColor: value,
            marginRight: '8px',
            marginTop: '8px',
            border: '1px solid black',
            cursor: 'pointer',
          }}></div>
        </div>

        { isColorPickerOpen &&
          <>
            <HexColorPicker color={safeValue} className="u-bumperLeft--sm" onChange={this.handleChangeDraft} />
            <Button buttonText='Confirm Color' className="u-bumperLeft--sm u-bumperTop--sm u-bumperBottom--sm" onClick={this.confirmDraftColor} />
          </>
        }
      </div>
    </>
  }

  private handleShowColorPicker = () => {
    this.setState({
      isColorPickerOpen: true,
      draftValue: this.props.value || DEFAULT_COLOR,
    })
  }

  private handleChangeSafely = (value) => {
    // TODO - why the heck does the text masking input call onChange before the whole mask matches??? so whack
    if (COLOR_RE.exec(value)) {
      this.props.onChange(value)
    }
  }

  private confirmDraftColor = () => {
    const { draftValue } = this.state

    this.setState({
      isColorPickerOpen: false,
    })

    this.props.onChange?.(draftValue)
  }

  private handleChangeDraft = (draftValue) => {
    this.setState({
      draftValue
    })
  }
}
